import React from 'react';
import { globalStateCTX } from '../../GlobalState/GlobalState';
import GaugeCard from './Gauge/GaugeCard';
import { KPIStatus } from '../KPIs/KPICard/KpiCard';
import { useNonce } from '../../Utils/hooks';
import { statisticsApi } from '../../Http/Http';
import { RoutineInspectionStatisticsReadView } from '../../GeneratedServices';
import { useTranslation } from 'react-i18next';
import { FilterValuesType } from '../../FiltersProvider/FiltersProvider';

interface Props {
  propertyId?: number;
  filterValues?: FilterValuesType;
}

const RoutineInspectionGauge: React.FC<Props> = (props) => {
  const { t } = useTranslation('common');

  const { handleHttpErrors } = React.useContext(globalStateCTX);

  const [routineInspectionStatistics, setRoutineInspectionStatistics] =
    React.useState<RoutineInspectionStatisticsReadView>();
  const [status, setStatus] = React.useState<KPIStatus>(KPIStatus.Loading);
  const [shouldReload, reload] = useNonce();

  React.useEffect(() => {
    const abortController = new AbortController();

    const load = async () => {
      try {
        setStatus(KPIStatus.Loading);
        const { data } = await statisticsApi.statisticsResourceReadRoutineInspectionStatistics({
          ...props.filterValues,
          propertyId: props.propertyId
        });

        setRoutineInspectionStatistics(data);
        setStatus(KPIStatus.None);
      } catch (error) {
        handleHttpErrors(error) && setStatus(KPIStatus.LoadError);
      }
    };
    load();

    return () => abortController.abort();
  }, [props.filterValues, props.propertyId, handleHttpErrors, shouldReload]);

  return (
    <GaugeCard
      title={t('routineWork')}
      data={[
        {
          id: '1',
          value: routineInspectionStatistics?.overdue ?? 0,
          label: t('late')
        },
        {
          id: '2',
          value: routineInspectionStatistics?.active ?? 0,
          label: t('active')
        },
        {
          id: '3',
          value: routineInspectionStatistics?.finished ?? 0,
          label: t('closed')
        }
      ]}
      status={status}
      retry={reload}
    />
  );
};

export default RoutineInspectionGauge;
